/// <amd-module name="Likes/Constants" />
export module SocialScopes {
    export var Collection = "Collection";
}
